/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Avatar, AvatarProps } from "@eds/react/Avatar";
import { CosmosLink } from "..";
import { CosmosAvatarFragment, CosmosEnumAvatarColors } from "@cosmos/hygraph-schema";
import { ElementType } from "react";

export type CosmosAvatarProps = {
	className?: string;
	as?: ElementType;
	size?: AvatarProps["size"];
	hideLabel?: AvatarProps["hideLabel"];
} & CosmosAvatarFragment;

export function CosmosAvatar({
	className = "",
	as = CosmosLink,
	label,
	href,
	color,
	imageSrc,
	imageAsset,
	size,
	hideLabel,
}: CosmosAvatarProps): React.JSX.Element | null {
	if (!label && !href && !imageSrc && !imageAsset) return null;

	//TODO remove brown from the enum
	let finalColor = color || CosmosEnumAvatarColors.Gray;
	// Handle legacy "brown" string value that may exist in old data
	if (finalColor === ("brown" as unknown as CosmosEnumAvatarColors)) {
		finalColor = CosmosEnumAvatarColors.Gray;
	}

	return (
		<Avatar
			className={className}
			as={as}
			href={href || ""}
			image={imageSrc || imageAsset?.optUrl || imageAsset?.url || ""}
			label={label || ""}
			color={finalColor as AvatarProps["color"]}
			size={size}
			hideLabel={hideLabel}
		/>
	);
}
